//scroll variable to track window's scroll
var lastScrollTop = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

resizeWindow();
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight +10) + 'px';
	}
}

var logoUrl = site_url + 'assets/svg/logo.svg';

if(windowWidth < 600){
	logoUrl = site_url + 'assets/svg/logo.svg';
	document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
}

// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//tablel burger menu
	document.getElementById('burgerMenuMb').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		}
	});

	//mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('primary-nav').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('primary-nav').classList.remove('open');
		}
	});

	// placerholder Mobile
	$("input#id_4_722").on("input",function(){
		if($(this).val().length>0){
		$(this).addClass("full");
	}
	else{
	$(this).removeClass("full");
	}
	});
	$("#home .header__btn").hide(); 
	$(window).scroll(function() {
		if ($(window).scrollTop() > 750) {
			$("#home .header__btn").fadeIn("slow");
		}
		else {
			$("#home .header__btn").fadeOut("slow");
		}
	});  
	
	//Home style
	$("#home #content .single-quad-seccion:nth-child(7) .single-quad").removeClass("container");
	$("#home #content .single-quad-seccion:nth-child(7) .single-quad").addClass("wrapper");

	$( "#form_id-722" ).on( "submit", function(){
		setTimeout( function(){
			$.fancybox.close();
		}, 3000 )
	});

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 5){
		if (st > lastScrollTop){
			// downscroll code 
			if(!document.getElementsByTagName('header')[0].classList.contains('down')){
				document.getElementsByTagName('header')[0].classList.add('down');
				document.getElementsByTagName('header')[0].classList.remove('up');


				document.getElementsByClassName('bottom-nav')[0].classList.add('down'); 
				document.getElementsByClassName('bottom-nav')[0].classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementsByTagName('header')[0].classList.contains('up')){
				document.getElementsByTagName('header')[0].classList.add('up');
				document.getElementsByTagName('header')[0].classList.remove('down');


				document.getElementsByClassName('bottom-nav')[0].classList.remove('down');
				document.getElementsByClassName('bottom-nav')[0].classList.add('up');
				
			}
		} 
	} else {
		if(document.getElementsByTagName('header')[0].classList.contains('up') || document.getElementsByTagName('header')[0].classList.contains('down')){
			document.getElementsByTagName('header')[0].classList.remove('up');
			document.getElementsByTagName('header')[0].classList.remove('down'); 

			document.getElementsByClassName('bottom-nav')[0].classList.remove('down');
			document.getElementsByClassName('bottom-nav')[0].classList.remove('up');
		}
	}
			//NO HOME
			if(!document.getElementById('home') && !document.getElementById('header').classList.contains('internal')){
				document.getElementById('header').classList.add('internal');
			}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow(){
	//calculate a new window size
	windowWidth = w.innerWidth||e.clientWidth||g.clientWidth;
	windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

	if(document.getElementsByClassName('img-slide').length > 0){
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for(let i = 0; i < headerImagesLength; i++){
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
// function offset(el) {
//     var rect = el.getBoundingClientRect(),
//     scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
//     scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
// } 